var map = {
	"./Bear New Year.webp": 371,
	"./Diamond Ring.webp": 16,
	"./Kissed Frog.webp": 249,
	"./Plush Pepe.webp": 110,
	"./Snoop Dogg.webp": 930,
	"./Statue of Liberty.webp": 724,
	"./Swiss Watch.webp": 94,
	"./Toy Bear.webp": 176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;